import contract from './contract'

export { contract }